/* global Office */

/**
 * Mirrors the Outlook add-in's theme detection: prefer Office's own reported
 * background color luminance, then fall back to the OS-level media query.
 */
export function isOfficeDarkTheme(): boolean {
  try {
    const theme =
      typeof Office !== "undefined" ? Office.context?.officeTheme : undefined;
    if (theme && theme.bodyBackgroundColor) {
      const hex = theme.bodyBackgroundColor.replace("#", "");
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      return luminance < 0.5;
    }
  } catch {
    // officeTheme not available — fall through to the OS-level check.
  }

  try {
    return (
      typeof window !== "undefined" &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    );
  } catch {
    return false;
  }
}
